import events from './events';

const Plugin = {
  install(Vue) {
    if (this.installed) return;
    this.installed = true;

    const init = (rootGetters, options) => {
      if (window.analyticsInitialized) return;
      window.analyticsInitialized = true;

      initFacebookPixel(options.facebookPixelId);
      initLocalytics(options.localyticsId, rootGetters);
      initGTM();
      initMarketo(rootGetters);
    };

    const config = rootGetters => {
      setLocalyticsDimensions(rootGetters);
    };

    Vue.prototype.$analytics = {
      config: config,
      events: events,
      init: init,
    };

    function setLocalyticsDimensions(rootGetters) {
      const user = rootGetters['session/currentUser'];
      if (window.ll && user) {
        let freePo = rootGetters['purchaseOrders/all'].find(po => po.purchaseOrderType === 'Tiered Pricing' && !po.parentId);
        let tieredPo = rootGetters['purchaseOrders/tieredPricing'].find(po => user.purchaseOrders.includes(po.id)) || freePo;
        let subscriptionPo = rootGetters['purchaseOrders/subscription'].find(po => user.purchaseOrders.includes(po.id)) || freePo;
        let answeredCount = rootGetters['user/answeredCount'];

        let appName = rootGetters['app/appName'];
        // Custom Dimensions
        ll('setCustomDimension', 0, user.email);                                    // User Email
        ll('setCustomDimension', 1, tieredPo?.formattedString);                     // Highest Tiered Pricing Tier
        ll('setCustomDimension', 5, 'true');                                        // Web App
        ll('setCustomDimension', 6, appName);                                       // App Name
        ll('setCustomDimension', 7, 'Stripe');                                      // Payment Method
        ll('setCustomDimension', 8, subscriptionPo?.formattedString);               // Subscription Tier
        ll('setCustomDimension', 9, user.signInCount);                              // Session Count
        ll('setCustomDimension', 10, answeredCount);                                // Practice Questions Answered
        ll('setCustomDimension', 11, 'true');                                       // WUX
        ll('setCustomDimension', 13, rootGetters['session/userClass']);             // Classification
        ll('setCustomDimension', 15, rootGetters['user/marketingSegment']);         // Marketing Segment

        // Standard User Attributes
        ll('setCustomerId', user.email);
        ll('setCustomerFirstName', user.firstName);
        ll('setCustomerLastName', user.lastName || '');
        ll('setCustomerFullName', `${user.firstName} ${user.lastName || ''}`);
        ll('setCustomerEmail', user.email);

        // Custom Profile Attributes
        ll('setProfileAttribute', 'Last Progress Reset', user.lastResetAt);
      }
    }

    function initGTM() {
      const containerId = process.env.GTM_CONTAINER_ID;
      if (!containerId) return;
      window.dataLayer = [];
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f&&f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer',containerId);
    }

    function initFacebookPixel(id) {
      if (!id || id === '') return;
      !function(f,b,e,v,n,t,s) {
        if (f.fbq) return;
        n = f.fbq = (...args) => (n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args));
        if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';n.queue = [];
        t = b.createElement(e);t.async = !0;t.src = v;
        s = b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', id);
    }

    function initLocalytics(id, rootGetters) {
      if (!id || id === '') return;
      !function(l, y, t, i, c, s) {
        l['LocalyticsGlobal'] = i;
        l[i] = (...args) => ((l[i].q = l[i].q || []).push(args));
        l[i].t = +new Date;
        (s = y.createElement(t)).type = 'text/javascript';
        s.src = '//web.localytics.com/v3/localytics.min.js';
        (c = y.getElementsByTagName(t)[0]).parentNode.insertBefore(s, c);
      }(window, document, 'script', 'll');
      ll('init', id, {});
      setLocalyticsDimensions(rootGetters);
    }

    function initMarketo(rootGetters) {
      if (rootGetters['productVars/get']['marketo_munchkin']?.value === 'true') {
        (function() {
          var didInit = false;
          function initMunchkin() {
            if(didInit === false) {
              didInit = true;
              if (window.Munchkin) {
                window.Munchkin.init('758-CUU-617');
              }
            }
          }
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = '//munchkin.marketo.net/munchkin.js';
          s.onreadystatechange = function() {
            if (this.readyState == 'complete' || this.readyState == 'loaded') {
              initMunchkin();
            }
          };
          s.onload = initMunchkin;
          document.getElementsByTagName('head')[0].appendChild(s);
        })();
      }

      if (rootGetters['productVars/get']['marketo_rtp']?.value === 'true') {
        (function(c,h,a,f,i,e){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments);};
        c[a].a=i;c[a].e=e;var g=h.createElement('script');g.async=true;g.type='text/javascript';
        g.src=f+'?aid='+i;var b=h.getElementsByTagName('script')[0];b && b.parentNode.insertBefore(g,b);
        })(window,document,'rtp','//sjrtp6-cdn.marketo.com/rtp-api/v1/rtp.js','hltcorp');
        rtp('send','view');
        rtp('get', 'campaign',true);
        window.rtp = rtp;
      }
    }
  },
};

export default Plugin;
